import { forwardRef } from 'react';

export const HipaaForm = forwardRef<HTMLDivElement>((props, ref) => (
  <div className="overflow-hidden w-full h-screen" ref={ref} {...props} />
));

HipaaForm.displayName = 'HipaaForm';
